/**
 * Converts a TN (digits only) into the provided format.
 * The provided format should contain "npa", "nxx", and "xxxx" arragned as desired.
 * These values will be replaced with the associated digits from the provided TN string.
 *
 * @module
 *
 * @param {string} tn TN (digits only)
 * @param {string} format How to format the TN
 * @returns {string} Formatted TN
 *
 * @example
 * import { formatTn } from '@somosengineering/js-util-lib';
 *
 * formatTn('3032131000', '(npa)nxx-xxxx');
 * // '(303)213-1000'
 */
const formatTn = (tn, format) => {
   if (tn == null || tn.length !== 10) {
      return tn;
   }
   return format
      .replace(/npa/i, tn.substring(0, 3))
      .replace(/nxx/i, tn.substring(3, 6))
      .replace(/xxxx/i, tn.substring(6, 10));
};

export { formatTn };
